/**
 * Returns the API base URL.
 * In production (same-origin), returns empty string for relative URLs.
 * In development, returns REACT_APP_BACKEND_URL.
 */
const getApiUrl = () => {
    const envUrl = process.env.REACT_APP_BACKEND_URL || '';
    if (typeof window !== 'undefined' && envUrl) {
        try {
            if (new URL(envUrl).origin === window.location.origin) return '';
        } catch (err) {
            // Malformed REACT_APP_BACKEND_URL — log to console once, fall back to the raw env value
            if (typeof console !== 'undefined' && console.warn) {
                console.warn('[api] Invalid REACT_APP_BACKEND_URL, using as-is:', envUrl, err?.message);
            }
        }
    }
    return envUrl;
};

const API_URL = getApiUrl();
export default API_URL;
